import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Dialog } from "@material-ui/core";

import "./paymentPreferences.scss";
import DonateButton from "./donateButton";
import AutoDonateContent from "./autoDonate";
import SavePaymentForm from "./savePaymentForm";
import AnimatedLoading from "../../../uiKit/Loading/animatedLoading";
import Title from "../../../uiKit/Title/Title";
import { useStylesDialog } from "../../../uiKit/CustomDialog/customDialog";
import CustomButton from "../../../uiKit/Button/CustomButton";
import { CircleDollar } from "../../../uiKit/assets/svg/icons";
import { blue500 } from "../../../uiKit/assets/colors/colors";

import { saveUserCard } from "../../../redux/state/paymentSlice";
import { setAutoDonateOpen } from "../../../redux/state/donationSlice";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY, { locale: "en" });

const PaymentPreferences = () => {
  const dispatch = useDispatch();
  const dialogClasses = useStylesDialog();

  const clientSecret = useSelector((state) => state.payment.preferencesClientSecret);
  const isLoading = useSelector((state) => state.payment.isLoading.saveUserCard);
  const screenWidth = useSelector((state) => state.common.screenWidth);
  const autoDonateOpen = useSelector((state) => state.donation.autoDonateOpen);
  const savedCard = useSelector((state) => state.payment.savedCard);

  useEffect(() => {
    if (!!clientSecret) return;
    dispatch(saveUserCard());
  }, [clientSecret, dispatch]);

  const closeAutoDonateHandler = () => {
    dispatch(setAutoDonateOpen(false));
  };

  const openAutoDonateHandler = () => dispatch(setAutoDonateOpen(true));

  return (
    <>
      <div className="paymentHeaderWrapper menu">
        <Title
          text="Payment preferences"
          fontSize={screenWidth < 900 ? 24 : 32}
          lineHeight={screenWidth < 900 ? 32 : 40}
        />
        <div className="paymentButtonsWrapper">
          <DonateButton />
          {!!savedCard?.id && (
            <>
              <CustomButton
                isWhite
                title="Auto Donate"
                onClick={openAutoDonateHandler}
                Icon={() => <CircleDollar color={blue500} />}
              />
              <Dialog
                open={autoDonateOpen}
                onClose={closeAutoDonateHandler}
                disableScrollLock={true}
                classes={dialogClasses}
                disableEnforceFocus
              >
                <AutoDonateContent />
              </Dialog>
            </>
          )}
        </div>
      </div>
      <div
        className="paymentPreferencesWrapper"
        style={{ position: "relative", minHeight: "350px" }}
      >
        {!!clientSecret && (
          <Elements stripe={stripePromise} options={{ clientSecret }}>
            <SavePaymentForm clientSecret={clientSecret} />
          </Elements>
        )}
        <AnimatedLoading loading={isLoading} />
      </div>
    </>
  );
};

export default PaymentPreferences;
